export const Getters = {

    isOverLimit: state => {
        return state.isOverLimit;
    },
}
